export enum EToastEvents {
    TOAST_FADE_IN = 'toast:fadeIn',
}
